import { type CaseRepository, CaseSearchContext } from '@telespot/domain';

/**
 * Use workspace ID to count the number of cases in a workspace.
 */
export interface ICountWorkspaceCasesQuery {
  /**
   * Count the number of cases in a workspace.
   * @param workspaceId The ID of the workspace to count cases in.
   * @param searchTerm Optional search term to filter cases by name.
   * @returns The number of cases in the workspace. Undefined if the operation fails. If the workspace does not exist, it will return zero.
   */
  execute(workspaceId: string, searchTerm?: string, searchContext?: CaseSearchContext): Promise<number | undefined>;
}

export class CountWorkspaceCasesQuery implements ICountWorkspaceCasesQuery {
  constructor(private readonly caseRepository: CaseRepository) {}

  public async execute(workspaceId: string, searchTerm?: string, searchContext?: CaseSearchContext): Promise<number | undefined> {
    try {
      return await this.caseRepository.countByWorkspace(workspaceId, searchTerm, searchContext);
    } catch (error) {
      console.error('Error counting cases in workspace:', error);
      return undefined;
    }
  }
}
